module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 77300.0667936d.png";